'use strict'

### Filters ###

angular.module('app.filters', [])

